import script from "./DefaultPlanHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultPlanHistory.vue?vue&type=script&setup=true&lang=js"

import "./DefaultPlanHistory.vue?vue&type=style&index=0&id=c399e81a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c399e81a"]])

export default __exports__